export function ClosedProjectIcon({className}: {className?: string}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M14.25 0C15.2165 0 16 0.783502 16 1.75V8.24805C16 8.66226 15.6642 9 15.25 9C14.8358 9 14.5 8.66421 14.5 8.25V6.5H6.5V14.5H7.25C7.66421 14.5 8 14.8358 8 15.25C8 15.6642 7.66317 15.9999 7.24902 16H1.75C0.783501 16 0 15.2165 0 14.25V1.75C0 0.783501 0.783502 0 1.75 0H14.25ZM1.5 14.25C1.5 14.3881 1.61193 14.5 1.75 14.5H5V6.5H1.5V14.25ZM1.75 1.5C1.61193 1.5 1.5 1.61193 1.5 1.75V5H5V1.5H1.75ZM6.5 1.5V5H14.5V1.75C14.5 1.61193 14.3881 1.5 14.25 1.5H6.5Z" />
      <path d="M15.9625 11.7368C15.9659 11.9311 15.8938 12.1191 15.7613 12.2613L12.2613 15.7613C12.1207 15.9017 11.93 15.9806 11.7313 15.9806C11.5325 15.9806 11.3419 15.9017 11.2013 15.7613L9.20129 13.7613C9.06881 13.6191 8.99669 13.4311 9.00012 13.2368C9.00355 13.0425 9.08226 12.8571 9.21967 12.7197C9.35708 12.5823 9.54247 12.5035 9.73677 12.5001C9.93107 12.4967 10.1191 12.5688 10.2613 12.7013L11.7313 14.1713L14.7013 11.2013C14.8435 11.0688 15.0315 10.9967 15.2258 11.0001C15.4201 11.0035 15.6055 11.0823 15.7429 11.2197C15.8803 11.3571 15.959 11.5425 15.9625 11.7368Z" />
    </svg>
  )
}
